export const visit = (vm, at) => {
vm(require("UIComponents/lang/en.lyaml"));
at({ "en": { "uiAddonConversationsSettings": { "helpDeskMigration": { "tooltip": { "channelBeingMovedToHelpDesk": "This channel is being moved to help desk. Please wait until it\u2019s completed before making updates to this channel." } } } } });
};